import { render, staticRenderFns } from "./planEditing.vue?vue&type=template&id=bb225048&scoped=true&"
import script from "./planEditing.vue?vue&type=script&lang=js&"
export * from "./planEditing.vue?vue&type=script&lang=js&"
import style0 from "./planEditing.vue?vue&type=style&index=0&id=bb225048&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb225048",
  null
  
)

export default component.exports